import { Injectable } from '@angular/core';
import { OAuthStorage } from 'angular-oauth2-oidc';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { Capacitor } from '@capacitor/core';

@Injectable({ providedIn: 'root' })
export class SecureOAuthStorage implements OAuthStorage {
  private memoryCache = new Map<string, string>();

  getItem(key: string): string | null {
    if (!Capacitor.isNativePlatform()) {
      return localStorage.getItem(key);
    }
    return this.memoryCache.get(key) || null;
  }

  removeItem(key: string): void {
    this.memoryCache.delete(key);
    if (Capacitor.isNativePlatform()) {
      SecureStoragePlugin.remove({ key }).catch((err) =>
        console.warn('Gagal hapus secure storage', err),
      );
    } else {
      localStorage.removeItem(key);
    }
  }

  setItem(key: string, data: string): void {
    this.memoryCache.set(key, data);
    if (Capacitor.isNativePlatform()) {
      SecureStoragePlugin.set({ key, value: data }).catch((err) =>
        console.warn('Gagal simpan secure storage', err),
      );
    } else {
      localStorage.setItem(key, data);
    }
  }

  async loadFromDevice(): Promise<void> {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    const keysToLoad = [
      'access_token',
      'refresh_token',
      'id_token',
      'expires_at',
      'nonce',
      'PKCE_verifier',
      'session_state',
    ];

    for (const key of keysToLoad) {
      try {
        const result = await SecureStoragePlugin.get({ key });
        if (result.value) {
          this.memoryCache.set(key, result.value);
        }
      } catch (error: any) {
        console.warn(`Key "${key}" tidak ditemukan atau error:`, error.message);
      }
    }
  }
}
